import {useEffect, useRef, useState} from "react";
import { RootState, useAppDispatch } from "../../../redux/store";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Loading from "../../helpers/Loading/Loading";
import {ObtenerFormasDePagoPorConductor, llenarBancoTarjeta, llenarMarcaTarjeta, llenarTipoTarjeta} from "../../../redux/actions/actionsLiquidacionRutas";
import { BigDecimal, TiposPago, CobroDTO } from "@pcgerente-node/pcg-comun"
import service from './serviceDetallesLiquidacionRutaDetalles';
import {InputHelper} from "../../../Utils/InputHelper";

interface ChildProps {
  idCiudadDestino: number;
  idCiudadUsario: number|null;
  idBodegaUsuario: number|null;
  saldoPendiente: BigDecimal;
  cobros: CobroDTO[];
  setCobros: (props: CobroDTO[]) => void;
}

const ModalAgregarCobro: React.FC<ChildProps> = ({
      idCiudadDestino,
      idCiudadUsario,
      idBodegaUsuario,
      saldoPendiente,
      cobros,
      setCobros,
}) => {

  const dispatch = useAppDispatch()
  const [show, setShow] = useState(false);
  const [nuevoCobro, setNuevoCobro] = useState(new CobroDTO());
  const [mensajeError, setMensajeError] = useState("")

  // Estados Globales correspondiente al store Redux
  const {formasDePagoCondutor, marcasTarjeta, tiposTarjeta, bancosTarjeta}
      = useSelector((state: RootState) => state.liquidacionRutas);

  const yaSeConsultoStore = useRef(false);
  useEffect(() => {
    if (show && !yaSeConsultoStore.current) {
      dispatch(ObtenerFormasDePagoPorConductor(idCiudadDestino, idCiudadUsario??0, idBodegaUsuario??0));


      dispatch(llenarBancoTarjeta());
      dispatch(llenarMarcaTarjeta());
      dispatch(llenarTipoTarjeta());

      yaSeConsultoStore.current = true;
    }

    setNuevoCobro(new CobroDTO());
  }, [show, idBodegaUsuario, idCiudadDestino]);

  const formatoInput: React.CSSProperties = {
    padding: ".5rem",
    borderColor: "solid 4px gray"
  }

  function storeEstaCargando(){
    return formasDePagoCondutor.loading || marcasTarjeta.loading || tiposTarjeta.loading || bancosTarjeta.loading
  }

  let idTipoPagoActual = nuevoCobro.FORMAPAGO?.TIPO_FORMA_PAGO?.idTipoPago||0

  return (
    <>
          <button
            className='btn btn-primary mt-3'
            onClick={() => setShow(true)}
            style={{ maxWidth: "200px" }}
          >
            Agregar Cobro
          </button>

      <Modal show={show}
        onHide={() => estadoInicial(true)}
        centered
        animation={false}
      >
        <Modal.Header>
          <Modal.Title>
            <div className='text-center'> Agregar/Editar Cobro</div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          { yaSeConsultoStore && !storeEstaCargando()?
            <>

              <div className="pb-2">
                <label className="d-block pb-0">Falta Justificar:</label>
                <label>${saldoPendiente.toFixed(2)}</label>
              </div>

              <div className="pb-2">
                <label >Forma de Pago:</label>
                <select
                  className="form-control country_code d-block"
                  color="white" id="payment-method-country"
                  value={nuevoCobro.idFormaPago}
                  onChange={(e) => handleInfo(e.target.value, "formaPago")}
                >
                  <option value={0} hidden>Seleccione una forma de Pago</option>
                  {formasDePagoCondutor.info.map((fp) =>
                    <option value={fp.id} key={fp.id}>{fp.descripcion}</option>
                  )}
                </select>
              </div>

              <div className="pb-2 d-flex flex-column">
                <span>monto</span>
                <input
                  style={formatoInput}
                  type="text"
                  value={"$" + nuevoCobro.montoStr}
                  onChange={(e) => handleInfo(e.target.value, "monto")}
                />
              </div>


              <div className="pb-2 d-flex flex-column">
                <span>Observación/Ret #</span>
                <input
                  style={formatoInput}
                  type="text"
                  value={nuevoCobro.observacion}
                  onChange={(e) => handleInfo(e.target.value, "observacion")}//# Retencion
                />
              </div>

              {[TiposPago.CHEQUE, TiposPago.TRANSFERENCIA].includes(idTipoPagoActual) ?
                <>
                  <div className="pb-2 d-flex flex-column ">
                    <span>Entidad Financiera</span>
                    <input
                      style={formatoInput}
                      type="text"
                      value={nuevoCobro.entidadFinanciera}
                      onChange={(e) => handleInfo(e.target.value, "entidadFinanciera")}//# Retencion
                    />
                  </div>
                  <div className="pb-2 d-flex flex-column ">
                    <span>Número Cuenta</span>
                    <input
                      style={formatoInput}
                      type="text"
                      value={nuevoCobro.numeroCuenta}
                      onChange={(e) => handleInfo(e.target.value, "numeroCuenta")}
                    />
                  </div>
                  <div className="pb-2 d-flex flex-column ">
                    <span>Fecha</span>
                    <input
                      style={formatoInput}
                      type="date"
                      value={nuevoCobro.fechaCheque ? new Date(nuevoCobro.fechaCheque).toISOString().split("T")[0] : ""}
                      onChange={(e) => handleInfo(e.target.value, "fechaCheque")}
                    />
                  </div>
                </>
                : <></>
              }

              {[TiposPago.TARJETA].includes(idTipoPagoActual) ?
              <>
                <div className="pb-2">
                  <span>Tipo de Tarjeta</span>
                  <select
                    className="form-control country_code"
                    color="white" id="payment-method-country"
                    value={nuevoCobro.idTipoTarjeta}
                    onChange={(e) => handleInfo(e.target.value, "idTipoTarjeta")}
                  >
                    <option value={0} hidden>Seleccione un tipo de tarjeta</option>
                    {tiposTarjeta.info.map(l =>
                      <option value={l.id} key={l.valor}>{l.descripcion}</option>
                    )}
                  </select>
                </div>

                <div className="pb-2">
                  <span>Marca de Tarjeta</span>
                  <select
                    className="form-control country_code"
                    color="white" id="payment-method-country"
                    value={nuevoCobro.idMarcaTarjeta}
                    onChange={(e) => handleInfo(e.target.value, "idMarcaTarjeta")}
                  >
                    <option value={0} hidden>Seleccione una Marca de tarjeta</option>
                    {marcasTarjeta.info.map(l =>
                      <option value={l.id} key={l.valor}>{l.descripcion}</option>
                    )}
                  </select>
                </div>
               
                <div className="pb-2 d-flex flex-column ">
                  <span>Banco de Tarjeta</span>
                  <select
                    className="form-control country_code"
                    color="white" id="payment-method-country"
                    value={nuevoCobro.idBancoTarjeta}
                    onChange={(e) => handleInfo(e.target.value, "idBancoTarjeta")}
                  >
                    <option value={0} hidden>Seleccione un Banco</option>
                    {bancosTarjeta.info.map(l =>
                      <option value={l.id} key={l.valor}>{l.descripcion}</option>
                    )}
                  </select>
                </div>
              </>
              :<></>
              }

              {[TiposPago.TARJETA, TiposPago.TRANSFERENCIA, TiposPago.CHEQUE].includes(idTipoPagoActual) ?
                <div className="pb-2 d-flex flex-column ">
                  <span>Número Cheque/Voucher/Lote</span>
                  <input
                    style={formatoInput}
                    type="text"
                    value={nuevoCobro.numeroCheque}
                    onChange={(e) => handleInfo(e.target.value, "numeroCheque")}
                  />
                </div>
                : <></>
              }
            </>
            :<Loading />
          }
        </Modal.Body>
        <Modal.Footer >
          <div className="d-flex justify-content-between w-100">
            <span className="text-danger">{mensajeError}</span>
            <div className="d-flex justify-content-end">
              <button
                className='btn btn-danger mr-2'
                onClick={() => estadoInicial(true)}>
                Cancelar
              </button>
              <button
                className='btn btn-primary mr-2'
                onClick={() => handlerAgregarCobro()}
              >
                Agregar
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )

  function handleInfo(value: string, campo: "monto" | "formaPago" | "observacion" | "entidadFinanciera" | "idTipoTarjeta" | "idBancoTarjeta" | "idMarcaTarjeta" | "fechaCheque" | "numeroCheque" | "numeroCuenta") {
    if (campo === "monto") {
      const valorStr = InputHelper.handleMoneyInput(value);

      if (valorStr !== '') {
        setNuevoCobro(prev => ({
          ...prev,
          montoStr: valorStr,
          monto: new BigDecimal(valorStr)
        }))
      }
    }

    if (["idTipoTarjeta", "idBancoTarjeta", "idMarcaTarjeta"].includes(campo)) {
      setNuevoCobro({
        ...nuevoCobro,
        [campo]: Number(value)
      })
    }

    if (campo === "formaPago") {
      const formaPagoSeleccionada = formasDePagoCondutor.info.find(fp => fp.id === Number(value))!!
      setNuevoCobro({
        ...nuevoCobro,
        idFormaPago: formaPagoSeleccionada.id,
        FORMAPAGO: formaPagoSeleccionada
      })
    }


    if (["observacion", "entidadFinanciera", "numeroCheque", "numeroCuenta"].includes(campo)) {
        setNuevoCobro({
          ...nuevoCobro,
          [campo]: value,
        })
    }

    if (campo === "fechaCheque") {
      setNuevoCobro({
        ...nuevoCobro,
        [campo]: new Date(value)
      })
    }

    setMensajeError("")
  }

  /**Limpia la información del modal */
  function estadoInicial(cerrarModal: boolean) {
    setNuevoCobro(new CobroDTO());
    setMensajeError("");
    yaSeConsultoStore.current = false;

    if (cerrarModal)
      setShow(false);
  }

  /**
   * Agrega un cobro al los cobros existentes.
   * En caso de que exista un cobro con la misma forma de pago, se unifican los cobros.
   *
   * */
  function handlerAgregarCobro() {
    const msgError = service.validarCobro(nuevoCobro, saldoPendiente);
    if (msgError) {
        return setMensajeError(msgError);
    }
    service.agregarCobro(nuevoCobro, cobros, setCobros);
    estadoInicial(true);
  }
}

export default ModalAgregarCobro;